import { application } from 'src';
import { Controller } from '@hotwired/stimulus';
import { findAll } from '@fretadao/f-js-dom';

application.register(
  'checkbox-list',
  class extends Controller {
    static targets = ['observer'];

    toggleAll(event) {
      let status = event.currentTarget.checked;

      this.#setAllCheckboxes(status);
    }

    checkAll() {
      this.#setAllCheckboxes(true);
    }

    checkNone() {
      this.#setAllCheckboxes(false);
    }

    #setAllCheckboxes(checked) {
      this.#checkboxes().forEach(el => {
        let checkbox = el;

        if (!checkbox.disabled) {
          checkbox.checked = checked;
        }
      });

      this.#notifyObservers();
    }

    #notifyObservers() {
      this.observerTargets.forEach((el) => {
        el.dispatchEvent(new CustomEvent('checkboxesChanged'))
      })
    }

    #checkboxes() {
      return findAll('input[type=checkbox]', this.element);
    }
  }
);
